/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/components/LineItems.tsx`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
import { Landmark } from 'lucide-react';
import { I } from './ui';
import { amt } from '../lib/format';
import '../styles/hints.css';

/** Aktivierungsgrenze (server/src/agents/lineItems.ts): an item with multi-year use from CHF 1'000 belongs on 15xx. */
const LIMIT = 100000;

/**
 * The Positionen of a Beleg as read by the extraction: a compact table, click-to-copy per cell.
 * They inform the review and the capitalisation check; the Beleg is still booked as one entry.
 * `capitalise` is set when the auditor raised asset.capitalise_item: only then are items from CHF 1'000
 * marked, so a service booked to 4400 is not flagged by a threshold the auditor deliberately skips.
 */
export function LineItems({ items, currency, capitalise = false }: { items: any[]; currency?: string | null; capitalise?: boolean }) {
  const cur = currency || 'CHF';
  return (
    <div className="table-wrap">
      <table className="data compact line-items" data-copy-surface>
        <thead><tr><th>Position</th><th className="r">Menge</th><th className="r">MWST</th><th className="r">Betrag {cur}</th></tr></thead>
        <tbody>{items.map((l, i) => {
          const amount = typeof (l.amount ?? l.total) === 'number' ? (l.amount ?? l.total) : null;
          const qty = l.quantity ?? l.qty;
          const desc = String(l.description ?? l.text ?? l.name ?? '—');
          return (
            <tr key={i}>
              <td className="desc" data-copy-value={desc}>{desc}
                {capitalise && cur === 'CHF' && amount != null && amount >= LIMIT && <span className="sub"><I icon={Landmark} sm /> über der Aktivierungsgrenze von CHF 1’000</span>}
              </td>
              <td className="r num">{qty ?? '—'}</td>
              <td className="r num">{typeof l.vatRate === 'number' ? `${l.vatRate / 100} %` : '—'}</td>
              <td className="r num">{amount != null ? amt(amount, false) : '—'}</td>
            </tr>
          );
        })}</tbody>
      </table>
    </div>
  );
}
